<template>
  <b-modal id="customer-show-bank-order" class="customer-show-order" ref="modal" title="Ver Remesas" hide-footer>
    <!-- DATA -->
    <div class="row form-group">
      <div class="col-sm-2">
        <input id="order_created_at" type="date" class="form-control readonly" :value="created_at" readonly />
        <label class="wabident-info" for="order_created_at">Fecha Creación</label>
      </div>
      <div class="col-sm-2">
        <input id="order_updated_at" type="date" class="form-control readonly" :value="updated_at" readonly />
        <label class="wabident-info" for="order_updated_at">Fecha Ult. Modificacióm</label>
      </div>
      <div class="col">
        <strong>TOTAL PAGOS: <span v-html="getTotalPayments()"></span></strong>
        <br>
        <strong>TOTAL CANTIDAD: <span v-html="getTotalAmount()"></span> </strong>
      </div>
    </div>
    <!-- PAYMENT LISTING -->
    <div class="row form-group">
      <div class="col-sm-12">
        <table class="table table-search-results">
          <thead>
            <tr>
              <th>FECHA</th>
              <th>PACIENTE</th>
              <th>CUENTA</th>
              <th>IBAN</th>
              <th>NIF</th>
              <th>CANTIDAD</th>
              <th>ESTADO</th>
              <th>ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <clinic-show-bank-order-item v-for="payment in payments" :key="payment.id" :payment="payment"
              :order="bank_order" @unlink="unlinkPayment" @pay="payPayment"></clinic-show-bank-order-item>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row form-group">
      <div class="col d-flex justify-content-around">
        <button v-if="can_delete" class="btn btn-wabident red mx-3" @click="deleteOrder">
          <i class="fas fa-trash"></i> Borrar
        </button>
        <button class="btn btn-wabident mx-3" @click="updatePayments">
          <i class="fas fa-undo"></i> Actualizar Pagos
        </button>
        <button v-if="can_download" class="btn btn-wabident mx-3" @click="downloadXML">
          <i class="fas fa-download"></i> Descarga XML
        </button>
        <button v-if="can_pay" class="btn btn-wabident green mx-3" @click="markAllPaid">
          <i class="fas fa-money-bill-alt"></i> Marcar pagados
        </button>
      </div>
    </div>

  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      bank_order: null,
    };
  },
  computed: {
    can_delete() {
      if (!this.bank_order) {
        return false;
      }

      const st = this.bank_order.status;
      return st == 'invalid' || st == 'xml_pending';
    },
    can_download() {
      if (!this.bank_order) {
        return false;
      }

      const st = this.bank_order.status;
      return st != 'invalid';
    },
    can_pay() {
      if (!this.bank_order) {
        return false;
      }

      const st = this.bank_order.status;
      return st == 'payment_pending';
    },
    payments() {
      if (!this.bank_order) return [];
      return this.bank_order.payments;
    },
    created_at() {
      if (!this.bank_order) return '';
      return moment(this.bank_order.created_at).format('YYYY-MM-DD');
    },
    updated_at() {
      if (!this.bank_order) return '';
      return moment(this.bank_order.updated_at).format('YYYY-MM-DD');
    },
    ...mapGetters(["msgwindow", "errorwindow", "clinic"]),
  },
  methods: {
    fmtAmount(amount) {
      return WabiDent.fmtMoney(amount);
    },
    show(order) {
      this.bank_order = order;
      this.$refs.modal.show();
    },
    updatePayments() {
      axios.get(`/bank_orders/${this.bank_order.id}/payments`).then((response) => {
        this.bank_order.payments = response.data.payments;
      }).catch((error) => {
        this.msgwindow.error('Error actualizando pagos del pedido');
      }).then(() => {
        this.$forceUpdate();
      });
    },
    downloadXML() {
      window.open(`/bank_orders/${this.bank_order.id}/xml`);
    },
    markAllPaid() {
      this.errorwindow.show('Confirmación', '¿Marcar todos como pagados?', 'Pagar', 'Cancelar', () => {
        axios.post(`/bank_orders/${this.bank_order.id}`, {
          '_method': 'patch'
        }).then((response) => {
          this.msgwindow.success('');
          this.bank_order.payments = response.data;
          this.$forceUpdate();
        }).catch((error) => {
          this.msgwindow.error('Error marcando pagos');
        }).then(() => {
          this.$emit('submit');
        })
      });
    },
    deleteOrder() {
      this.errorwindow.show('Confirmación', 'Esto desvinculará todos los pagos de la Remesa. ¿Está seguro?', 'Borrar', 'Cancelar', () => {
        axios.post(`/bank_orders/${this.bank_order.id}`, {
          '_method': 'delete'
        }).then((response) => {
          this.msgwindow.success('Remesa borrada con éxito. Puedes volver a asociar los pagos luego');
        }).catch((error) => {
          this.msgwindow.error('Error borrando ');
        }).then(() => {
          this.$refs.modal.hide();
          this.$emit('submit');
        })
      });
    },
    unlinkPayment(payment) {
      this.errorwindow.show('Confirmación', '¿Desvincular este pago de la Remesa?', 'Desvincular', 'Cancelar', () => {
        axios.post(`/bank_orders/${this.bank_order.id}/payments/${payment.id}`, {
          '_method': 'delete'
        }).then((response) => {
          this.msgwindow.success('Pago desvinculado');
          this.bank_order.payments = response.data;
          this.$forceUpdate();
        }).catch((error) => {
          this.msgwindow.error('Error desvinculando remesa');
        }).then(() => {
          this.$emit('submit');
        })
      });
    },
    payPayment(payment) {
      this.errorwindow.show('Confirmación', '¿Marcar como pagado?', 'Pagar', 'Cancelar', () => {
        axios.post(`/bank_orders/${this.bank_order.id}/payments/${payment.id}`, {
          '_method': 'patch'
        }).then((response) => {
          this.msgwindow.success('');
          this.bank_order.payments = response.data;
          this.$forceUpdate();
        }).catch((error) => {
          this.msgwindow.error('Error marcando pago');
        }).then(() => {
          this.$emit('submit');
        })
      });
    },
    getTotalPayments() {
      if (!this.bank_order) return '';
      return this.bank_order.payments.length;
    },
    getTotalAmount() {
      if (!this.bank_order) return '';
      let amount = 0;
      this.bank_order.payments.forEach((p) => {
        amount += p.amount;
      })
      return this.fmtAmount(amount);
    },
  },
};
</script>

<style lang="scss">
#customer-show-bank-order {
  .modal-dialog {
    max-width: 75%;
  }
}
</style>
